import { render, staticRenderFns } from "./ThePresentationCard.component.vue?vue&type=template&id=0310b18c"
import script from "./ThePresentationCard.component.vue?vue&type=script&lang=js"
export * from "./ThePresentationCard.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports